import { ConfigurationVariables } from 'environments/configuration-variables';
import _ from 'lodash';

export const environment = _.assignIn(new ConfigurationVariables, {
  production: true,
});
